<template>
    <div>
        <div class="exceptionResource-title">
            <Breadcrumb>
                <BreadcrumbItem>{{ $t('configuration_management.customized_alarm_config.customizedAlarmConfig') }}</BreadcrumbItem>
                <BreadcrumbItem>{{ $t('configuration_management.customized_alarm_config.exceptionResources') }}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem to="/configurationManagement/customerDefinedAlarmConfiguration">{{this.$route.query.monitorModuleName}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="exceptionResource-top">
            <add-instances v-if="this.$route.query.monitorModule==0"></add-instances>
            <add-volumes v-if="this.$route.query.monitorModule==11"></add-volumes>
            <add-databases v-if="this.$route.query.monitorModule==1"></add-databases>
            <add-server-load-balancing v-if="this.$route.query.monitorModule==27||this.$route.query.monitorModule==6"></add-server-load-balancing>
        </div>
    </div>
</template>

<script>
    import AddInstances from '../exception_resource/ec2/AddInstances'
    import AddDatabases from '../exception_resource/rds/AddDatabases'
    import AddVolumes from '../exception_resource/ebs/AddVolumes'
    import AddServerLoadBalancing from '../exception_resource/slb/AddServerLoadBalancing'

    export default {
        name: 'ExceptionResource',
        components: {
            AddInstances,
            AddDatabases,
            AddVolumes,
            AddServerLoadBalancing
        }
    }
</script>

<style scoped>
    .exceptionResource-title
    {
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 10px 12px;
        background-color: #f8f8f9;
    }
    .exceptionResource-top
    {
        width: 100%;
        height: 53px;
        padding: 10px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/ExceptionResource.vue